'use client';
import { FC, useEffect, useState } from 'react';

import useAudioRoutingStore from 'state/audioRoutingStore';
import { useAudioStore } from 'state/sfx/audioStore';

export interface AudioControllerProps {}

const AudioController: FC<AudioControllerProps> = () => {
  const isAllowedAudio = useAudioStore(s => s.isAllowed);
  const setIsAllowedAudio = useAudioStore(s => s.setIsAllowed);
  const isExperiencePlaying = useAudioRoutingStore(s => s.isPlaying);
  const setIsExperiencePlaying = useAudioRoutingStore(s => s.setIsPlaying);

  const [isDocumentHidden, setIsDocumentHidden] = useState<boolean | undefined>(
    undefined
  );
  const [wasPlayingAudio, setWasPlayingAudio] = useState(false);
  const [wasPlayingExperience, setWasPlayingExperience] = useState(false);

  useEffect(() => {
    if (isAllowedAudio === undefined) {
      return;
    }
    if (!navigator) {
      return;
    }
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      return;
    }
    const handleVisibilityChange = () => {
      setIsDocumentHidden(document.hidden);
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isAllowedAudio]);

  useEffect(() => {
    if (isAllowedAudio === undefined || isDocumentHidden === undefined) {
      return;
    }

    if (isDocumentHidden) {
      setWasPlayingAudio(!!isAllowedAudio);
      setWasPlayingExperience(!!isExperiencePlaying);
      setIsAllowedAudio(false);
      setIsExperiencePlaying(false);
    } else {
      setIsAllowedAudio(wasPlayingAudio);
      setIsExperiencePlaying(wasPlayingExperience);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDocumentHidden, setIsAllowedAudio, setIsExperiencePlaying]);

  return null;
};
export default AudioController;
